import React from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

const Searchbar = (props) => {
  const classes = useStyles();
  const handleChange = (e) => {
    props.handleChange(e.target.value);
  };
  return (
    <TextField
      id="outlined-bare"
      className={classes.textField}
      defaultValue=""
      placeholder="Type Here To Search"
      margin="normal"
      variant="outlined"
      style={{ width: "90%" }}
      onChange={handleChange}
    />
  );
};
const useStyles = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

export default Searchbar;
